'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _buttonGroup = require('../button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class TwitterLoginButton
  * A component for logging a user into the virtual
  * expo using thier Twitter account.
  * @prop {function} onError an error handler for issues
  * arising in the login process.  It should expect an error
  * object as the only parameter.
  */
var TwitterLoginButton = function (_Component) {
  _inherits(TwitterLoginButton, _Component);

  function TwitterLoginButton(props) {
    _classCallCheck(this, TwitterLoginButton);

    var _this = _possibleConstructorReturn(this, (TwitterLoginButton.__proto__ || Object.getPrototypeOf(TwitterLoginButton)).call(this, props));

    _this.handleTwitterSignin = _this.handleTwitterSignin.bind(_this);
    return _this;
  }
  /** @method handleTwitterSignin
    * Prompts the user to sign in with Twitter.
    */


  _createClass(TwitterLoginButton, [{
    key: 'handleTwitterSignin',
    value: function handleTwitterSignin() {
      var _this2 = this;

      var provider = new firebase.auth.TwitterAuthProvider();
      //provider.addScope('user_birthday');
      window.vexpo.firebase.auth().signInWithPopup(provider).then(function (result) {
        // This gives you a Twitter Access Token.
        //var token = result.credential.accessToken;
        // The signed-in user info.
        //var user = result.user;
      }).catch(function (error) {
        _this2.props.onError(error);
      });
    }
    /** @method render
      * Renders the Twitter login button.
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _buttonGroup2.default,
        null,
        _react2.default.createElement(
          'button',
          { className: 'twitter', onClick: this.handleTwitterSignin },
          'Sign in with ',
          _react2.default.createElement(_reactFontawesome2.default, { name: 'twitter' })
        )
      );
    }
  }]);

  return TwitterLoginButton;
}(_react.Component);

exports.default = TwitterLoginButton;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/twitter/twitter-login-button.js
// module id = 909
// module chunks = 0